import { useGetList } from "ra-core";

import type { Deal } from "../types";
import { DashboardActivityLog } from "./DashboardActivityLog";
import { DealsChart } from "./DealsChart";
import { HotContacts } from "./HotContacts";
import { LeadDashboardKpis } from "./LeadDashboardKpis";
import { TasksList } from "./TasksList";
import { Welcome } from "./Welcome";

export const Dashboard = () => {
  const { total: totalDeal } = useGetList<Deal>("deals", {
    pagination: { page: 1, perPage: 1 },
  });

  return (
    <div className="flex flex-col gap-6 mt-1">
      <LeadDashboardKpis />
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        <div className="md:col-span-3">
          <div className="flex flex-col gap-4">
            {import.meta.env.VITE_IS_DEMO === "true" ? <Welcome /> : null}
            <HotContacts />
          </div>
        </div>
        <div className="md:col-span-6">
          <div className="flex flex-col gap-6">
            {totalDeal ? <DealsChart /> : null}
            <DashboardActivityLog />
          </div>
        </div>

        <div className="md:col-span-3">
          <TasksList />
        </div>
      </div>
    </div>
  );
};
